export default __webpack_public_path__ + "static/media/help-circle-outline.71cb50c7.svg";